import "@arco-design/web-react/es/Modal/style";
import _Modal from "@arco-design/web-react/es/Modal";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import "@arco-design/web-react/es/Notification/style";
import _Notification from "@arco-design/web-react/es/Notification";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import { intl } from 'di18n-react';
/*
 * @Author: songjunlong
 * @Date: 2024-11-27 09:28:24
 * @LastEditors: songjunlong
 * @LastEditTime: 2024-11-27 09:31:45
 * @FilePath: \node-master\src\components\NavBar\Password.tsx
 */
import { useEffect } from 'react';
import { useRequest } from 'ahooks';
import { UserService } from '@/service';
import { useHistory } from 'react-router-dom';
const Cpn = props => {
  const {
    visible,
    setVisible
  } = props;
  const [form] = _Form.useForm();
  const history = useHistory();
  const {
    run: postPasswordModifyRun,
    loading: postPasswordModifyLoading
  } = useRequest(UserService.postUserPassword, {
    manual: true,
    onSuccess: res => {
      _Notification.success({
        title: intl.t('修改成功'),
        content: intl.t('密码修改成功，请重新登录'),
        duration: 2000
      });
      setVisible(false);
      setTimeout(() => {
        localStorage.removeItem('nms_token');
        localStorage.removeItem('nms_userName');
        localStorage.removeItem('nms_userStatus');
        history.push('/nms/login');
      }, 1000);
    }
  });
  useEffect(() => {
    //
  }, []);
  return /*#__PURE__*/React.createElement(_Modal, {
    title: intl.t('修改密码'),
    visible: visible,
    confirmLoading: postPasswordModifyLoading,
    onOk: () => {
      form.validate().then(values => {
        postPasswordModifyRun(values);
      });
    },
    onCancel: () => {
      setVisible(false);
    }
  }, /*#__PURE__*/React.createElement(_Form, {
    form: form
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    label: intl.t('原密码'),
    field: "oldPassword",
    required: true,
    rules: [{
      required: true,
      message: intl.t('请输入原密码')
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, null)), /*#__PURE__*/React.createElement(_Form.Item, {
    label: intl.t('新密码'),
    field: "password",
    required: true,
    rules: [{
      required: true,
      message: intl.t('请输入新密码')
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, null)), /*#__PURE__*/React.createElement(_Form.Item, {
    label: intl.t('确认密码'),
    field: "confirmPwd",
    required: true,
    rules: [{
      required: true,
      message: intl.t('请输入确认密码')
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, null))));
};
export default Cpn;